import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBoldDownFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M13.993,8h-1.993V2.75c0-.965-.785-1.75-1.75-1.75h-2.5c-.965,0-1.75,.785-1.75,1.75v5.25h-1.993c-.479,0-.907,.266-1.12,.695-.212,.428-.165,.931,.124,1.311l4.993,6.581c.239,.314,.602,.494,.996,.494s.757-.18,.996-.495l4.993-6.581c.289-.38,.336-.883,.124-1.311-.213-.429-.642-.695-1.12-.695Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconArrowBoldDownFill18.js.map